import ActionBlock, { ActionBlockProps } from './ActionBlock';

export type { ActionBlockProps };
export default ActionBlock;
